export const QUOTATION_INSURANCE_CARRIER_STATE = Object.freeze({
  PENDING: 'pending',
  STARTED: 'started',
  PROCESSING: 'processing',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
});

export const QUOTATION_INSURANCE_CARRIER_NON_TERMINAL_STATES = Object.freeze([
  QUOTATION_INSURANCE_CARRIER_STATE.PENDING,
  QUOTATION_INSURANCE_CARRIER_STATE.STARTED,
  QUOTATION_INSURANCE_CARRIER_STATE.PROCESSING,
]);
